<template>
  <div>
    <el-select v-model="_clientId" class="mr-3" placeholder="選擇客戶" clearable @clear="onClear" @change="onSelect">
      <el-option v-for="item in clients" :key="item.id" :label="item.name" :value="item.id" />
    </el-select>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { getCompanyClients } from '@/api/clients';
export default {
  props: {
    companyId: {
      default: null,
    },
    clientId: {
      default: null,
    },
  },
  data() {
    return {
      clients: [],
    };
  },
  computed: {
    ...mapGetters(['company']),
    _clientId: {
      get() {
        return this.clientId;
      },
      set(val) {
        this.$emit('update:clientId', val);
      },
    },
  },
  watch: {
    async companyId() {
      // console.log(`client companyId ${this.companyId}`);
      this.clients = await getCompanyClients(this.companyId);
      this._clientId = null;
      this.onSelect();
    },
  },

  async created() {
    this.clients = await getCompanyClients(this.companyId);
    this.$emit('onSelect');
  },
  methods: {
    onSelect() {
      this.$emit('onSelect');
    },
    onClear() {
      this._clientId = null;
      this.onSelect();
    },
  },
};
</script>
